import tracking from 'dibs-tracking';

const trackFollowSearch = (isSelected, position) => {
    const action = isSelected ? 'added' : 'removed';

    tracking.trackEvent({
        category: 'search favoriting',
        action: `search ${action}`,
        label: `${position} of results`,
        value: 0,
    });
};

export const trackFollowSearchBanner = isSelected => {
    trackFollowSearch(isSelected, 'bottom');
};

export const trackFollowSearchButton = isSelected => {
    trackFollowSearch(isSelected, 'top');
};
